import script from "./NumPad.vue?vue&type=script&setup=true&lang=js"
export * from "./NumPad.vue?vue&type=script&setup=true&lang=js"

import "./NumPad.vue?vue&type=style&index=0&id=5b022968&scoped=true&lang=sass"

import exportComponent from "/Users/nika/Documents/Projects/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b022968"]])

export default __exports__